export const addtocardreq='addtocartreq'
export const addtocartsucc="addtocartsucc"
export const addtocartfail="addtocartfail"